/** Starter prompts shown in empty chat areas (EPIC-6). */

export const BEHAVIOR_STARTER_PROMPTS = [
  'What strategies help with off-task behavior during transitions?',
  'Help me draft a positive behavior support plan',
  'How can I track progress on a replacement behavior?',
] as const;

export const INSTRUCTION_STARTER_PROMPTS = [
  'Plan a small-group lesson for students who need extra support',
  "Suggest formative checks for this week's learning goal",
  'How can I differentiate this activity for ELL students?',
] as const;

export const TEACHING_CHAT_STARTER_PROMPTS = [
  'Create a bell ringer for my grade level',
  "Draft exit ticket questions for today's lesson",
  'Explain a concept in simple terms for my students',
] as const;
